export default __webpack_public_path__ + "92bef7e45fed3caba8dc9348edef4df2.png";